import React from 'react'
import useDoorbellsApi from '../hooks/doorbells/useDoorbellsApi'
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import DotsBackground from '../components/common/DotsBackground'
import logoSpotter from '../images/spotter-logo.svg'

export default function UserInvitationsPage() {
  const [{ createDoorbellState }, { requestAccessDoorbell }] = useDoorbellsApi()
  let { id } = useParams()
  const classes = useStyles()
  const ref1 = React.useRef(null)
  const ref2 = React.useRef(null)
  const ref3 = React.useRef(null)
  const ref4 = React.useRef(null)
  const ref5 = React.useRef(null)
  const [value1, setValue1] = React.useState('')
  const [value2, setValue2] = React.useState('')
  const [value3, setValue3] = React.useState('')
  const [value4, setValue4] = React.useState('')
  const [value5, setValue5] = React.useState('')
  const code = value1 + value2 + value3 + value4 + value5
  return (
    <div className={classes.wrapper}>
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            fontSize: '22px',
            fontWeight: 'bold',
            color: 'white',
            flexDirection: 'column',
            alignItems: 'flex-start',
            maxWidth: '768px',
            margin: '0 auto',
            padding: '20px 10px',
          }}
        >
          <img
            src={logoSpotter}
            style={{ marginBottom: '20px', marginRight: '40px' }}
            // height="180px"
            width="180px"
            alt="spotter"
          ></img>
          <span>Código de verificación</span>
          <span
            style={{
              fontSize: '16px',
              fontWeight: 'regular',
              margin: '10px 0',
              textAlign: 'left',
            }}
          >
            Ingrese el código de verificación enviado a su correo
          </span>
        </div>
        <div className={classes.inputsWrapper}>
          <input
            className={classes.input}
            maxLength={1}
            ref={ref1}
            value={value1}
            onChange={(evt) => {
              setValue1(evt.target.value)
              ref2.current.focus()
            }}
          />
          <input
            className={classes.input}
            maxLength={1}
            ref={ref2}
            value={value2}
            onChange={(evt) => {
              setValue2(evt.target.value)
              ref3.current.focus()
            }}
          />
          <input
            className={classes.input}
            maxLength={1}
            ref={ref3}
            value={value3}
            onChange={(evt) => {
              setValue3(evt.target.value)
              ref4.current.focus()
            }}
          />
          <input
            className={classes.input}
            maxLength={1}
            ref={ref4}
            value={value4}
            onChange={(evt) => {
              setValue4(evt.target.value)
              ref5.current.focus()
            }}
          />
          <input
            className={classes.input}
            maxLength={1}
            ref={ref5}
            value={value5}
            onChange={(evt) => setValue5(evt.target.value)}
          />
        </div>
        <div style={{ color: '#d51616', marginTop: '30px', fontSize: '20px' }}>
          {createDoorbellState.error?.message}
        </div>
        <div style={{ color: 'green', marginTop: '30px', fontSize: '20px' }}>
          {createDoorbellState.success && !createDoorbellState.error && "Puerta abierta!"}
        </div>
      </div>
      <DotsBackground></DotsBackground>

      <Button
        className={classes.buttonsMargin}
        type="submit"
        variant="contained"
        color="primary"
        onClick={(evt) => requestAccessDoorbell(id, code)}
        tabIndex={0}
      >
        Abrir puerta
      </Button>
    </div>
  )
}
const useStyles = makeStyles((theme) => ({
  input: {
    width: '90px',
    height: '110px',
    color: 'white',
    fontSize: '26px',
    marginRight: '10px',
    textAlign: 'center',
    borderRadius: '10%',
    textTransform: 'uppercase',
    backgroundColor: '#242934',
    border: 'none',
    '@media (max-width: 600px)': {
      width: '85px',
      height: '85px',
      fontSize: '20px',
    },
    '@media (max-width: 500px)': {
      width: '57px',
      height: '85px',
      fontSize: '20px',
    },
    '@media (max-width: 400px)': {
      width: '35px',
      height: '60px',
      fontSize: '20px',
    },
  },
  wrapper: {
    overflow: 'hidden',
    height: '93vh',
    padding: '50px 50px',
    backgroundColor: '#191d26',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: 'bold',
    '@media (max-width: 450px)': {
      padding: '50px 20px',
    },
  },
  buttonsMargin: {
    width: '100%',
    height: '40px',
    maxWidth: '550px',
    position: 'fixed',
    bottom: '50px',
    '@media (max-width: 500px)': {
      maxWidth: '250px',
    },
  },
  inputsWrapper: {
    margin: '0 auto',
    width: '100%',
    maxWidth: '540px',
    whiteSpace: 'nowrap',
    '& > input:focus': {
      border: '2px solid rgba(48, 104, 249, 0.7)',
      outline: 'none',
    },
  },
}))
